import React, { useState, useEffect } from 'react';

const ProgressStepper = ({ currentStep, totalSteps, visibleSteps }) => {
  const [stepWidth, setStepWidth] = useState(0);

  // Calculate the visible current step (excluding hidden steps)
  const getVisibleCurrentStep = () => {
    let visibleStep = 0;
    const hiddenSteps = [6, 7, 8]; // loading, createAccount, login
    for (let i = 0; i <= currentStep; i++) {
      if (!hiddenSteps.includes(i)) {
        visibleStep++;
      }
    }
    return visibleStep - 1; // Subtract 1 because we want 0-based index
  };

  const visibleCurrentStep = getVisibleCurrentStep();

  // Calculate step width based on fixed container width
  const getStepWidth = () => {
    // Desktop: 505px, Mobile: 355px
    const containerWidth = window.innerWidth > 768 ? 505 : 355;
    const gap = 4; // 4px gap between steps
    const totalGaps = totalSteps - 1;
    const availableWidth = containerWidth - totalGaps * gap;
    return availableWidth / totalSteps;
  };

  useEffect(() => {
    const updateStepWidth = () => {
      const newWidth = getStepWidth();
      console.log(
        'ProgressStepper: Container width:',
        window.innerWidth > 768 ? 505 : 355,
        'Step width:',
        newWidth,
        'Total steps:',
        totalSteps,
      );
      setStepWidth(newWidth);
    };

    // Set initial width
    updateStepWidth();

    // Add resize listener
    window.addEventListener('resize', updateStepWidth);

    // Cleanup
    return () => {
      window.removeEventListener('resize', updateStepWidth);
    };
  }, [totalSteps]);

  return (
    <div className="progress-stepper">
      {Array.from({ length: totalSteps }, (_, index) => (
        <div
          key={index}
          className="progress-step"
          style={{ width: `${stepWidth}px` }}
        >
          <div
            className={`progress-bar ${
              index <= visibleCurrentStep ? 'progress-filled' : ''
            }`}
          />
        </div>
      ))}
    </div>
  );
};

export default ProgressStepper;
